import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 31 31"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M15.929 16.183 7.84 24.27a.786.786 0 0 1-1.11-1.111l8.086-8.088h-7.53a.786.786 0 1 1 0-1.571h9.431a.78.78 0 0 1 .551.229l.003.003a.78.78 0 0 1 .229.554v9.428a.786.786 0 0 1-1.571 0z"
    }
  ),
  /* @__PURE__ */ React.createElement("rect", { width: 10.833, height: 10.833, x: 18.583, y: 1.583, fill: "#FCBB26", rx: 5.417 }),
  /* @__PURE__ */ React.createElement(
    "rect",
    {
      width: 10.833,
      height: 10.833,
      x: 18.583,
      y: 1.583,
      stroke: "#fff",
      strokeWidth: 2.167,
      rx: 5.417
    }
  )
);
var SvgVoicemailSubmittedOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var VoicemailSubmittedOutlined_default = SvgVoicemailSubmittedOutlined;

export { VoicemailSubmittedOutlined_default as default };
